if (!window.__SL_toast__) {
  /**
   * Toast notification utility.
   */
  class Toast {
    constructor() {
      this.defaultDuration = 5000;
    }

    show(options) {
      const { message, type = 'info', duration = this.defaultDuration } = options;

      const toast = document.createElement('div');
      toast.className = `sa-theme toast-container toast-${type}`;

      const iconSpan = document.createElement('span');
      iconSpan.className = `toast-icon ${type}-icon`;
      toast.appendChild(iconSpan);

      toast.appendChild(document.createTextNode(message));

      document.body.appendChild(toast);

      setTimeout(() => {
        toast.classList.add('toast-fade-out');
        setTimeout(() => {
          toast.remove();
        }, 300);
      }, duration);
    }

    error(options) {
      this.show({ ...options, type: 'error' });
    }

    success(options) {
      this.show({ ...options, type: 'success' });
    }

    info(options) {
      this.show({ ...options, type: 'info' });
    }
  }

  window.__SL_toast__ = new Toast();
}
